namespace Solovis.Reports.Parameters {
  export class BoolParameterControl extends Solovis.UI.BaseControl {
    static count = 0;
    public static hasNewRender = true;

    public initialParameterValue;
    public checkboxInput: JQuery;

    constructor(options, info) {
      super(options, info);

      this.initialParameterValue =
        typeof options.initialValue != "undefined"
          ? options.initialValue
          : false;
    }

    public static getLabel(value): string | undefined {
      if (value === true) return "True";
      if (value === false) return "False";
      return undefined;
    }

    public doInit() { }

    private async doRenderNew() {
      var self = this;

      const id = Solovis.UX.Utils.generateId();
      const target = this.container[0];
      await Solovis.UX.Utils.placeComponent(
        "Checkbox",
        target,
        {
          id,
          label: this.info.label,
          help: this.info.help,
          paramInfo: Solovis.UX.Utils.getTooltipFromParamInfo(this.info),
        }
      );
      this.checkboxInput = $(`#${id}`);

      if (this.initialParameterValue !== null) {
        this.checkboxInput.prop("checked", this.initialParameterValue == true);
      }

      $(this.checkboxInput).change(function () {
        self.notifyParameterValueChanged();
      });
    }

    private doRenderClassic() {
      var self = this;

      this.checkboxInput = $("<input>")
        .attr("type", "checkbox")
        .appendTo(this.container);

      if (this.initialParameterValue !== null) {
        this.checkboxInput.prop("checked", this.initialParameterValue == true);
      }

      $(this.checkboxInput).change(function () {
        self.notifyParameterValueChanged();
      });
    }
  
    public doRender() {
      if (this.options.renderMode === 'modern') {
          this.doRenderNew();
      } else {
          this.doRenderClassic();
      }
    }

    public setParameterValue(newValue) {
      if (this.checkboxInput) {
        this.checkboxInput.prop("checked", newValue);
      } else {
        this.initialParameterValue = newValue;
      }
    }

    public getParameterValue() {
      if (this.checkboxInput) {
        var checked = this.checkboxInput.prop("checked") == true;
        return checked;
      } else {
        return this.initialParameterValue;
      }
    }

    public notifyParameterValueChanged() {
      $(this).trigger("parameterValueChanged");
    }
  }
}
